@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';

.rate-browser-modal {
  width: 1000px;
  height: 860px;

  @media @tablet, @mobile, @ultramobile {
    max-width: 100vw;
    max-height: 100vh;
  }
}

.rate-browser-modal-body {
  display: flex;
  position: relative;
  align-items: stretch;
  flex: 1;

  @media @mobile, @ultramobile {
    flex-direction: column;
    overflow: hidden;
  }
}

.left-side-wrapper {
  background: @rate-browser-modal-form--background-color;
  width: 300px;
  min-width: 300px;
  border-right: 1px solid @rate-browser-modal-form--border-color;
  position: relative;
  z-index: 2;

  @media @mobile, @ultramobile {
    width: 100%;
    min-width: 100%;
    min-height: 280px;
    max-height: 40%;
    overflow-y: auto;
    border-right: none;
    border-bottom: 1px solid @rate-browser-modal-form--border-color;
  }
}

.right-side-wrapper {
  width: calc(100% - 300px);
  position: relative;
  z-index: 1;

  @media @mobile, @ultramobile {
    width: 100%;
    flex: 1;
    min-height: 0;
  }
}
